import { useState } from "react";
import { FaAsterisk } from "react-icons/fa";
import { Select } from "../../SharedModule/components/Select";
import { useModal } from "../../SharedModule/hooks/useModal";
import { formatForDropdowns } from "../../SharedModule/utils/formatters";
import { Client } from "../types/clients-module-types";
import { ClientsService } from "../services/clients";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { useDispatch } from "react-redux";
import eventHandler from "../../SharedModule/utils/eventHandler";

export const ModalAddEditRelationshipReview = ({
  btnCancel,
  clients,
  costCenters,
  isClientsLoading,
  isLoadingAllCostCenters,
  editMode,
  isClientTabPage,
  reviewToEdit,
  clientId,
  costCenterOwnedIds,
}: any) => {
  const dispatch = useDispatch();

  const filteredCostCenters = costCenterOwnedIds
    ? costCenters.filter((cc) => costCenterOwnedIds.includes(cc.value))
    : costCenters;

  const [reviewName, setReviewName] = useState(
    editMode ? reviewToEdit.name : ""
  );
  const clientsList = clients
    .filter((cl) => cl.isActive)
    .map(formatForDropdowns<Client>("companyName"));

  const [client, setClient] = useState(
    isClientTabPage || (!isClientTabPage && editMode)
      ? clientsList.find(
          (elem) => Number(elem.value) === (clientId ?? reviewToEdit.clientId)
        ) ?? { value: 0, label: "Select Client" }
      : { value: 0, label: "Select Client" }
  );
  const [costCenter, setCostCenter] = useState(
    editMode
      ? filteredCostCenters.find(
          (cc) => cc.value === reviewToEdit.costCenterId
        ) ?? {
          value: reviewToEdit.costCenterId,
          label: `${reviewToEdit.costCenterId} - ${reviewToEdit.costCenterName} (x)`,
        }
      : {
          value: 0,
          label: "Select Cost Center",
        }
  );

  const [formTouched, setFormTouched] = useState(false);
  const [buttonPressed, setButtonPressed] = useState(false);

  const { showModal, closeModal, Modal, ...modalProps } = useModal();

  const handleChange = (value: string) => {
    setFormTouched(true);
    setReviewName(value);
  };

  const handleRelationship = async () => {
    setButtonPressed(true);
    if (editMode) {
      await ClientsService.updateRelationshipReview({
        clientId: Number(client.value),
        costCenterId: costCenter.value,
        name: reviewName,
        id: reviewToEdit.id,
        isActive: reviewToEdit.isActive,
      })
        .then((response) => {
          btnCancel(true, false);
          dispatch(addToast({ mode: "success", message: response.message }));
        })
        .catch((error) => {
          btnCancel(false, false);
          dispatch(
            addToast({
              mode: "error",
              message: error.data.errors[error.data.errors.length - 1],
            })
          );
        });
    } else {
      await ClientsService.addRelationshipReview({
        clientId: Number(client.value),
        costCenterId: costCenter.value,
        name: reviewName,
      })
        .then((response) => {
          btnCancel(true, true);
          dispatch(addToast({ mode: "success", message: response.message }));
        })
        .catch((error) => {
          btnCancel(false, false);
          dispatch(
            addToast({
              mode: "error",
              message: error.data.errors[error.data.errors.length - 1],
            })
          );
        });
    }
    eventHandler.dispatch("toast action", { isClosed: false });
  };

  return (
    <>
      <Modal closeModal={closeModal} {...modalProps} />
      <h4 className="text-center text-capitalize">
        {editMode ? "Edit Relationship Review" : "Add New Relationship Review"}
      </h4>
      <hr style={{ width: "100%" }} />

      <div className="d-flex mt-2 flex-column mb-2">
        <label className="mb-1">
          Relationship Name{" "}
          <span className="required">
            <FaAsterisk size={"6px"} />
          </span>
        </label>
        <input
          type="text"
          name="reviewName"
          autoComplete="off"
          className="form-control form-control-sm"
          value={reviewName}
          onChange={(event) => handleChange(event.target.value)}
          style={{ height: "38px" }}
        />
      </div>
      <div className="d-flex mt-2 flex-column mb-2">
        <label className="mb-1">
          Client{" "}
          <span className="required">
            <FaAsterisk size={"6px"} />
          </span>
        </label>
        <Select
          placeholder="Select Client"
          className="mb-2"
          options={clientsList}
          isLoading={isClientsLoading}
          value={client}
          onChange={(client: any) => {
            setClient(client);
            setFormTouched(true);
          }}
          isDisabled={isClientTabPage}
        />
      </div>
      <div className="d-flex mt-2 flex-column mb-2">
        <label className="mb-1">
          Cost Center{" "}
          <span className="required">
            <FaAsterisk size={"6px"} />
          </span>
        </label>
        <Select
          placeholder="Select Cost Center"
          className="mb-2"
          options={filteredCostCenters}
          isLoading={isLoadingAllCostCenters}
          value={costCenter}
          onChange={(cc: any) => {
            setCostCenter(cc);
            setFormTouched(true);
          }}
        />
      </div>
      <hr style={{ width: "100%" }} />
      <div className="d-flex mt-2">
        <button
          className="btn button-secondary w-100"
          onClick={() => btnCancel(false)}
          disabled={buttonPressed}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary w-100 ms-2"
          disabled={
            reviewName.length === 0 ||
            Number(client.value) === 0 ||
            costCenter.value === 0 ||
            buttonPressed ||
            !formTouched
          }
          onClick={() => handleRelationship()}
        >
          {editMode ? "Update" : "Add"}
        </button>
      </div>
    </>
  );
};
